import React, { Component } from 'react';
import { Input, Button, Form , FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import { FaCircleNotch } from 'react-icons/fa';
import { setField } from '../../../Utilities/Common';
import Actions from '../../../Actions';

class RequestResetForm extends Component{

    constructor(props){
        super(props);
        this.state = {email: ''};
    }
    
    setField = (endpoint, option, type = 0) => {
        setField(endpoint, option, type, (dataObj) => {
            this.setState((state) => ({...state,...dataObj}));
        });
    }

    render(){
        const { email } = this.state;
        const { loading: { requestReset: loading }, requestReset } = this.props;
        return (
            <Form>
                <FormGroup>
                    <Input id="email" onChange={(event) => this.setField('email',event)} value={ email } type="email" name="email" placeholder="Email" />
                </FormGroup>
                <FormGroup>
                    <Button disabled={ loading } onClick={() => {requestReset(email)}} block color="primary">
                        {loading ? <FaCircleNotch className="icon-spin" style={{marginRight: '5px', verticalAlign:'text-bottom'}} />:false }
                        Reset
                    </Button>
                </FormGroup>
            </Form>
        );
    }
}

const mapStateToProps = (state) => (
    {
      loading: state.auth.loading
    }
);

export default connect(mapStateToProps, Actions.auth)(RequestResetForm);


// WEBPACK FOOTER //
// ./src/Components/Auth/Layout/RequestResetForm.js